export function objectKeys<Value, Key extends string>(
  object: Record<Key, Value>,
) {
  return Object.keys(object) as Key[];
}
